import { useQuery } from 'react-query';
import SourceORM, {Source} from '@models/source';

export const useSource = (sourceId: string) =>
    useQuery<Source>({ queryKey: ['source', sourceId], queryFn: () => SourceORM.findById(sourceId) });